export const getAdminPortalIdFromPathname = (pathname: string): number | null => {
  const segment = pathname.split('/')[2]
  if (!segment || !/^\d+$/.test(segment)) return null

  return Number(segment)
}

const hasPortalRouteSegment = (pathname: string): boolean => {
  const segment = pathname.split('/')[2]
  return Boolean(segment && segment !== 'orders' && segment !== 'reports')
}

type ShouldRedirectToDefaultPortalArgs = {
  pathname: string
  requestedPortalIsAccessible: boolean
}

export const shouldRedirectToDefaultAdminPortal = ({
  pathname,
  requestedPortalIsAccessible
}: ShouldRedirectToDefaultPortalArgs): boolean =>
  pathname === '/admin' ||
  pathname === '/admin/orders' ||
  (hasPortalRouteSegment(pathname) && !requestedPortalIsAccessible)
